import React from 'react'
import styled from 'styled-components'

interface Props {
  vimeoID: number
  title?: string
}

export const VimeoVideo: React.FC<Props> = ({ title, vimeoID }) => {
  if (!vimeoID) {
    return null
  }

  return (
    <IframeContainer>
      <iframe
        title={title}
        src={`https://player.vimeo.com/video/${vimeoID}`}
        width="100%"
        height="100%"
        allow="autoplay; fullscreen"
        allowFullScreen
      />
    </IframeContainer>
  )
}

const IframeContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`
